// src/modules/app-views/_apps/appmulti/quotations/pages/Document/decorators/response.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import dayjs from 'dayjs';

// *******************************************************************************
// RESPONSE DECORATOR
// Ports legacy quotations.js decorateDocument: derive __travelPeriod + inclusive days.
// *******************************************************************************
function decorateResponse(doc) {
  if (!doc?.departure || !doc?.arrival) return doc;
  doc.__travelPeriod = [dayjs(doc.departure), dayjs(doc.arrival)];
  doc.days = dayjs(doc.arrival).diff(doc.departure, 'days') + 1;
  return doc;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default decorateResponse;
